var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 17.5,
    height: 17.5,
    rx: 2,
    fill: "#0D0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4847 7.6733C14.4003 7.6297 14.3182 7.5819 14.2386 7.53008C14.0072 7.37708 13.795 7.1968 13.6066 6.99313C13.1353 6.45383 12.9593 5.90673 12.8944 5.52367H12.897C12.8429 5.20572 12.8653 5 12.8686 5H10.7219V13.3011C10.7219 13.4126 10.7219 13.5228 10.7172 13.6316C10.7172 13.6451 10.7159 13.6576 10.7151 13.6722C10.7151 13.6782 10.7151 13.6845 10.7138 13.6907C10.7138 13.6923 10.7138 13.6938 10.7138 13.6954C10.6912 13.9932 10.5957 14.281 10.4358 14.5332C10.2759 14.7855 10.0564 14.9946 9.79666 15.1422C9.52599 15.2962 9.21984 15.377 8.90843 15.3766C7.90822 15.3766 7.09758 14.561 7.09758 13.5537C7.09758 12.5465 7.90822 11.7309 8.90843 11.7309C9.09776 11.7307 9.28593 11.7605 9.46595 11.8192L9.46856 9.63336C8.92206 9.56277 8.36687 9.6062 7.838 9.76092C7.30914 9.91563 6.81807 10.1783 6.39579 10.5323C6.02578 10.8538 5.7147 11.2374 5.47657 11.6658C5.38595 11.8221 5.04404 12.4499 5.00263 13.4688C4.97659 14.0472 5.15028 14.6464 5.23309 14.894V14.8992C5.28517 15.0451 5.48698 15.5427 5.81587 15.9622C6.08108 16.2987 6.39441 16.5943 6.74578 16.8395V16.8343L6.75098 16.8395C7.79025 17.5457 8.94254 17.4994 8.94254 17.4994C9.14201 17.4913 9.81021 17.4994 10.569 17.1398C11.4106 16.7411 11.8898 16.1471 11.8898 16.1471C12.1959 15.7922 12.4393 15.3877 12.6095 14.9511C12.8038 14.4404 12.8686 13.8279 12.8686 13.5832V9.17922C12.8947 9.19484 13.2415 9.42426 13.2415 9.42426C13.2415 9.42426 13.7413 9.74456 14.5209 9.95314C15.0803 10.1016 15.8339 10.1328 15.8339 10.1328V8.00167C15.5698 8.03032 15.0336 7.94699 14.4847 7.6733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d824aea946a20fbc296f29b05e743658.svg";
export { ForwardRef as ReactComponent };